// removed by extract-text-webpack-plugin
module.exports = {"header":"style__header___301UU","header--open":"style__header--open___12mvT","right-arrow":"style__right-arrow___2M6MH","arrow":"style__arrow___BGTUQ","arrow-browser":"style__arrow-browser___3SuOF","arrow-mobile":"style__arrow-mobile___3yApU","arrow-box":"style__arrow-box___41QiH","title":"style__title___1HvLL"};


//////////////////
// WEBPACK FOOTER
// ./components/EventAccordionTitle/style.scss
// module id = 1204
// module chunks = 0